import { render, staticRenderFns } from "./MoverNotasReceptor.vue?vue&type=template&id=3c416bd1"
import script from "./MoverNotasReceptor.vue?vue&type=script&lang=js"
export * from "./MoverNotasReceptor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports